module.exports = __webpack_public_path__ + "static/media/res_film.04c2bb3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/sigatoka_negra/alternative/res_film.png
// module id = 1168
// module chunks = 3